import type { ObjektPanelKey } from '../../../../../components/immobilien/objektPanels';
import { AliasePanel } from './AliasePanel';
import { DienstleisterPanel } from './DienstleisterPanel';
import { DokumentePanel } from './DokumentePanel';
import { KontaktePanel } from './KontaktePanel';
import { TerminePanel } from './TerminePanel';
import { ZaehlerPanel } from './ZaehlerPanel';
import { BelegungPanel } from './BelegungPanel';
import { EhemaligePanel } from './EhemaligePanel';
import { EigentuemerPanel } from './EigentuemerPanel';
import { FlaechePanel } from './FlaechePanel';
import { KaltmietePanel } from './KaltmietePanel';
import { KartePanel } from './KartePanel';
import { NotizenPanel } from './NotizenPanel';
import { StammPanel } from './StammPanel';
import { ZustaendigPanel } from './ZustaendigPanel';
import { BerichtPanel } from './BerichtPanel';
import { FinanzenPanel } from './FinanzenPanel';
import { AktivitaetPanel, EtvPanel, MieterhoehungPanel, SchluesselPanel, TicketsPanel, VersicherungPanel, VertraegePanel, WartungPanel, WegPanel } from './E8Panels';

/** Inhalt des Morph-Panels je Schlüssel. Nur angebundene Panels (ANGEBUNDENE_PANELS) werden geöffnet. */
export function PanelInhalt({ panel }: { panel: ObjektPanelKey }) {
  switch (panel) {
    case 'stamm': return <StammPanel />;
    case 'karte': return <KartePanel />;
    case 'flaeche': return <FlaechePanel />;
    case 'beleg': return <BelegungPanel />;
    case 'kalt': return <KaltmietePanel />;
    case 'ehem': return <EhemaligePanel />;
    case 'eigent': return <EigentuemerPanel />;
    case 'zust': return <ZustaendigPanel />;
    case 'aliase': return <AliasePanel />;
    case 'notizen': return <NotizenPanel />;
    case 'termine': return <TerminePanel />;
    case 'zaehler': return <ZaehlerPanel />;
    case 'dokumente': return <DokumentePanel />;
    case 'kontakte': return <KontaktePanel />;
    case 'dienstleister': return <DienstleisterPanel />;
    case 'tickets': return <TicketsPanel />;
    case 'wartung': return <WartungPanel />;
    case 'versich': return <VersicherungPanel />;
    case 'vertraege': return <VertraegePanel />;
    case 'etv': return <EtvPanel />;
    case 'keys': return <SchluesselPanel />;
    case 'protokoll': return <AktivitaetPanel />;
    case 'mieterh': return <MieterhoehungPanel />;
    case 'weg': return <WegPanel fokus="weg" />;
    case 'wplan': return <WegPanel fokus="wplan" />;
    case 'bericht': return <BerichtPanel />;
    case 'finanzen': return <FinanzenPanel />;
    default: return null;
  }
}
